import { jsxs as l, jsx as d } from "react/jsx-runtime";
const a = ({ currency: e }) => /* @__PURE__ */ l("div", { className: "text-xxs relative inline-flex leading-5 rounded-md px-2 py-1 font-bold uppercase", children: [
  /* @__PURE__ */ d("div", { className: "bg-THEME-primary absolute left-0 top-0 h-full w-full rounded-md opacity-30" }),
  e
] });
export {
  a as CurrencyBadge
};
